import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Small slate pill showing a step's flow number. Reused across the canvas-node
 * badge, the step-detail panel, the inputs section, and the step pickers so a
 * step is recognisable by the same number everywhere.
 */ export function StepNumberBadge({ number, title }) {
    return /*#__PURE__*/ _jsx("span", {
        title: title,
        className: "shrink-0 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-fg-secondary text-white text-[9px] font-semibold leading-none",
        children: number
    });
}

//# sourceMappingURL=StepNumberBadge.js.map